import type { TAppUser } from '@core/backend'
import { getSessionFromLocalStorage, waitForSessionRestore } from '@core/http-client'
import { GUEST_USER } from '../constants/guestUser'
import { fetchCurrentUser } from './fetchCurrentUser'

// Guest without a request when there is no bearer, so the query can stay permanently enabled —
// gating with `enabled` would leave every observer armed at logout and fire a round of 401s.
export const fetchSessionUser = async (): Promise<TAppUser> => {
    await waitForSessionRestore()

    return getSessionFromLocalStorage() ? fetchCurrentUser() : GUEST_USER
}
